let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ad6rq")).then(() => parcelRequire('5stxY'));